import { UseQueryOptions } from '@tanstack/react-query';

import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

import type { AccessCentrePermissionsApiResponse } from 'domains/accessCentre/types';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

type UseGetPermissionsListParams = {
    limit?: number;
    offset?: number;
    reactQueryOptions?: UseQueryOptions<AccessCentrePermissionsApiResponse, Error>;
};

const useGetPermissionsList = ({
    limit = DEFAULT_LIMIT,
    offset = DEFAULT_OFFSET,
    reactQueryOptions,
}: UseGetPermissionsListParams = {}) => {
    const queryKey = QueryKeys.ACCESS_CENTRE_PERMISSIONS(limit, offset);
    const params = { limit, offset };
    const axiosOptions = { params };

    return useQuery<AccessCentrePermissionsApiResponse>(
        queryKey,
        CuredApiPaths.ACCESS_CENTRE_PERMISSIONS,
        reactQueryOptions,
        axiosOptions
    );
};

export default useGetPermissionsList;
